import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/weak-map";
import "core-js/es6/string";
import "core-js/fn/array/includes";
import "core-js/fn/promise";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import formActionSaga from "redux-form-saga";
import history from "utils/history";
import store, { sagaMiddleware } from "store/configureStore";
import rootSaga from "ducks/sagas";
import { setLocale } from "ducks/user/actions";
import { App } from "containers";
import "./index.scss";
import registerServiceWorker from "./registerServiceWorker";

sagaMiddleware.run(rootSaga);
sagaMiddleware.run(formActionSaga);

/* added for leverage direct lang urls from base site */
if (["en", "es", "pt", "zh"].includes(window.location.pathname.split("/")[1])) {
  store.dispatch(setLocale(window.location.pathname.split("/")[1].toUpperCase()));
}

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById("root"),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js